export const WEB_LOGIN = 'WEB_LOGIN';
export const WEB_LOGOUT = 'WEB_LOGOUT';
export const SET_ORDER_TYPES = 'SET_ORDER_TYPES';
export const CLEAR_STATE_DATA = 'CLEAR_STATE_DATA';
export const SET_ACTIVE_TABLE_ORDER = 'SET_ACTIVE_TABLE_ORDER';
export const CLEAR_ACTIVE_TABLE_ORDER = 'CLEAR_ACTIVE_TABLE_ORDER';
export const SET_TABLE_ORDERS = 'SET_TABLE_ORDERS';
